import { MutationTree } from 'vuex';
import store from '@/store/store';
import { Error } from '@/store/types';
import { DataRegion, Region, RegionState } from './types';

export const mutations: MutationTree<RegionState> = {
  REGION_SUCCESS: (state, payload: DataRegion[]) => {
    state.dataRegion = new Array<DataRegion>();
    let arrayFilter = payload.sort((a: any, b: any): any => {
      return a.name.localeCompare(b.name);
    });
    arrayFilter.map((value: Region, key: number) => {
      state.dataRegion!.push(DataRegion.fromJSON(value));
    });
  },
  REGION_ERROR: (state, payload: Error) => {
    state.dataRegion = undefined;
    store.commit('alert/SHOW', {
      prefix: 'REGION_ERROR_',
      error: payload.status,
    });
  },
  REGION_ADD_ERROR: (state, payload: Error) => {
    store.commit('alert/SHOW', {
      prefix: 'REGION_ADD_ERROR_',
      error: payload.status,
    });
  },
  REGION_PUT: (state, payload) => {
    if (state.dataRegion) {
      for (let i = 0; i < state.dataRegion.length; i++) {
        if (payload._id === state.dataRegion[i]._id) {
          state.dataRegion[i].adminsites!.push(payload.select);
        } else if (state.dataRegion[i]._id === undefined) {
          state.dataRegion[i].adminsites.push(payload);
        }
      }
    }
  },
  REGION_PUT_ERROR: (state, payload: Error) => {
    store.commit('alert/SHOW', {
      prefix: 'REGION_PUT_ERROR_',
      error: payload.status,
    });
  },
  REGION_DELETE_ERROR: (state, payload: Error) => {
    state.dataRegion = undefined;
    store.commit('alert/SHOW', {
      prefix: 'REGION_DELETE_ERROR_',
      error: payload.status,
    });
  },
  REGION_ADMINSITE_CREATE: (state) => {
    if (state.dataRegion && state.dataRegion.length === 0) {
      state.dataRegion.push(new DataRegion());
    } else if (
      state.dataRegion &&
      state.dataRegion.length !== 0 &&
      state.dataRegion[state.dataRegion.length - 1]._id &&
      state.dataRegion[state.dataRegion.length - 1]._id !== undefined
    ) {
      state.dataRegion.push(new DataRegion());
    }
  },
  REGION_ADMINSITE_DELETE: (state, payload) => {
    if (state.dataRegion) {
      for (let i = 0; i < state.dataRegion.length; i++) {
        if (payload._id === state.dataRegion[i]._id) {
          state.dataRegion[i].adminsites!.splice(payload.index, 1);
        }
      }
    }
  },
};
